import {projectCode} from "../resources/constants";

export const generalDetailsReducer = (state = "", action) => {
    switch (action.type) {
        case "SET_GENERALDETAILS_DETAILS":
            return action.payload;

        default:
            return state;
    }
};

export const permissionDetailsReducer = (state = [], action) => {
    switch (action.type) {
        case "SET_PERMISSION_DATA":
            return action.payload;

        default:
            return state;
    }
};

export const loginDetailsReducer = (state = "", action) => {
    switch (action.type) {
        case "SET_LOGIN_DETAILS":
            return action.payload;

        default:
            return state;
    }
};
export const applicationDetailsReducer = (state = "", action) => {
    switch (action.type) {
        case "SET_APPLICATION_DETAILS":
            return action.payload;

        default:
            return state;
    }
};

export const ApplicationRequirementDetailsReducer = (state = [], action) => {
    switch (action.type) {
        case `SET_${projectCode}_APPLICATION_REQUIREMENT_DETAILS`:
            return action.payload;
        default:
            return state;
    }
};

export const JambRequirementDetailsReducer = (state = [], action) => {
    switch (action.type) {
        case `SET_${projectCode}_JAMB_REQUIREMENT_DETAILS`:
            return action.payload;
        default:
            return state;
    }
};

export const OLevelRequirementDetailsReducer = (state = [], action) => {
    switch (action.type) {
        case `SET_${projectCode}_OLevel_REQUIREMENT_DETAILS`:
            return action.payload;
        default:
            return state;
    }
};
